import { Injectable } from '@angular/core';
import { UsuarioAPI } from '../../core/models/AuthModel';
import { SystemResponse } from '../../features/dashboard/models/SystemsModel';
import { KeyStorageUtil } from './keystorage';
import {Usuario} from '../../features/user/models/usuario';
import {environment} from '../../../enviroments/enviroment';
import {LoaderService} from '../../core/services/loader/loader-service';
import {Router} from '@angular/router';
import {DOCUMENT, Inject} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilCatService {
  static readonly adminProfile: string = 'ROLE_ADMIN';
  static readonly perfilNewUser: string = 'ROLE_USERNEW';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private loaderService: LoaderService
  ) {}

  public static isSuperUser() {
    const user: UsuarioAPI = KeyStorageUtil.getItem('usuario')!;
    let su = false;
    user.perfil.forEach((element) => {
      if (element.codigo === UtilCatService.adminProfile) {
        su = true;
      }
    });
    return su;
  }

  public static hasNewUserProfile(): boolean {
    const user: UsuarioAPI = KeyStorageUtil.getItem('usuario')!;
    if (user.perfil.length === 1) {
      if (user.perfil[0].codigo.trim() === this.perfilNewUser.trim()) {
        return true;
      }
    }
    return false;
  }

  public static getUserUniqueSystems(): SystemResponse[] {
    const user: UsuarioAPI = KeyStorageUtil.getItem('usuario')!;
    let systems: SystemResponse[] = [];
    user.perfil.forEach((element) => {
      element.sistemas.forEach((system) => {
        systems.push(system);
      });
    });

    const resplist = Array.from(
      new Set(systems.map((item: SystemResponse) => item))
    );

    const resp: any = {};
    systems = resplist.filter((o) =>
      resp[o.id] ? false : (resp[o.id] = true)
    );

    return systems;
  }

  //obtener rutas permitidas
  public static getAllowedRoutes(route: string): boolean {
    const user: UsuarioAPI = KeyStorageUtil.getItem('usuario')!;
    if (UtilCatService.isSuperUser()) {
      // Si es super usuario se le da todos los accesos
      return true;
    }
    let allowed: boolean = false;
    user.perfil.forEach((element) => {
      element.menus.forEach((menu) => {
        if (route.trim().includes(menu.ruta.trim())) {
          allowed = true;
          return;
        }
      });
    });
    return allowed;
  }

  public static contienePerfilUsuarioNuevo(user: Usuario): boolean {
    if (user.perfil.length == 1) {
      if (user.perfil[0].codigo.trim() == this.perfilNewUser.trim()) {
        return true;
      }
    }
    return false;
  }

  public enterTheSystem(item: SystemResponse) {

    KeyStorageUtil.setItem('activeSystem', item.id.toString());
    if (item.ruta.startsWith('../')) {
      const urlToCat = item.ruta.replace('../', '');
      this.document.location.href = environment.catUrlEndPoint + urlToCat;
      return;
    }
    if (item.ruta.includes('https-')) {
      const keyUrl = item.ruta?.split('https-')?.at(1)!;
      this.document.location.href = (environment as any)[keyUrl];
      return;
    }

    this.router.navigate([item.ruta]);
  }
}
